import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { ChartSpecification } from '../../../../dataModels/chart-data-model';

declare var AmCharts;

@Component({
    selector: 'solid-gauge-chart',
    templateUrl: 'solid-gauge.component.html',
    styleUrls: ['solid-gauge.component.css', '../../charts.style.scss']
})

export class SolidGaugeChartComponent implements OnInit, AfterViewInit {

    @Input() chartSpecification: ChartSpecification;

    constructor() { }

    ngOnInit() {
        this.chartSpecification.title = this.chartSpecification.title || "";
        this.chartSpecification.theme = this.chartSpecification.theme || "none";
        this.chartSpecification.chartColor = this.chartSpecification.chartColor || "";
        this.chartSpecification.data = this.chartSpecification.data || [];
        this.chartSpecification.yAxisTitle = this.chartSpecification.yAxisTitle || "";
        this.chartSpecification.xAxis = this.chartSpecification.xAxis || "xAxis";
        this.chartSpecification.yAxis = this.chartSpecification.yAxis || "yAxis";
        this.chartSpecification.divId = this.chartSpecification.divId || "multiDiv";
        this.chartSpecification.graphs = this.chartSpecification.graphs || [];
        this.chartSpecification.valueAxes = this.chartSpecification.valueAxes || [];
        this.chartSpecification.EnableValueAxisLabels = this.chartSpecification.EnableValueAxisLabels || false;
        this.chartSpecification.endAngle = this.chartSpecification.endAngle || 270;
    }

    ngAfterViewInit() {
        this.drawChart();
    }

    drawChart() {
        setTimeout(() => {

            let chartSettings = this.getChartSettings();

            AmCharts.makeChart(this.chartSpecification.divId, {
                "hideCredits": true,
                "type": "gauge",
                "theme": this.chartSpecification.theme,
                "titles": [{
                    "size": 12,
                    "text": this.chartSpecification.title
                }],
                "axes": [{
                    "axisAlpha": 0,
                    "tickAlpha": 0,
                    "labelsEnabled": false,
                    "startValue": 0,
                    "endValue": 100,
                    "startAngle": 0,
                    "endAngle": this.chartSpecification.endAngle,
                    "bands": chartSettings.bands
                }],
                "allLabels": chartSettings.labels,
                "export": {
                    "enabled": true,
                    "fileName": this.chartSpecification.title
                }
            });
        }, 20);
    }

    getChartSettings() {
        let bands: any[] = [];
        let labels: any[] = []

        let length = this.chartSpecification.graphs.length;
        let data = this.chartSpecification.data;

        this.chartSpecification.graphs.forEach((item, index) => {
            bands.push({
                "color": "#eee",
                "startValue": 0,
                "endValue": 100,
                "radius": (100 - (index * 20)) + "%",
                "innerRadius": (85 - (index * 20)) + "%"
            });

            bands.push({
                "color": item.color,
                "startValue": data[index][this.chartSpecification.xAxis],
                "endValue": data[index][this.chartSpecification.yAxis],
                "radius": (100 - (index * 20)) + "%",
                "innerRadius": (85 - (index * 20)) + "%",
                "balloonText": data[index][this.chartSpecification.yAxis] + "%"
            });

            labels.push({
                "text": item.title,
                "x": "49%",
                "y": (19 + ((index * 7) - index)) + "%",
                "size": 10,
                "bold": true,
                "color": item.color,
                "align": "right"
            });
        });

        labels.push({
            "text": this.chartSpecification.yAxisTitle,
            "x": "7%",
            "y": "65%",
            "bold": true,
            "size": 11,
            "rotation": 270
        })

        return { bands, labels };
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/gaugeCharts/solid-gauge/solid-gauge.component.ts